export const convertSecondsToTime = (seconds: number) => {
  // the time returned is in the format of mm:ss
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const minutesWithPad = minutes < 10 ? '0' + minutes : minutes;
  const secondsWithPad =
    remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds;
  return `${minutesWithPad}:${secondsWithPad}`;
};
